import { createContext, useEffect, useState } from "react";
import { IDashboardContext, IErrors, IMetadata } from "../../interfaces";

/**
 * Contexto do Dashboard para gerenciamento de metadados e estado do painel de controle.
 * @type {React.Context<IDashboardContext>}
 */
export const DashboardContext = createContext<IDashboardContext>({
  metadata: {
    id_lote: undefined,
    id_imobiliario: undefined,
    id_pessoa: undefined,
    id_imobiliario_pessoa: undefined,
    id_edificacao: undefined,
    id_imobiliario_edificacao: undefined,
    id_midia: undefined,
    id_visitas: undefined,
    id_mensagens: undefined,
    formularios: undefined,
    drawer: true,
    permissoes: undefined,
  },
  setMetadata: () => {},
  errors: {},
  setErrors: () => {},
  totalPages: 1,
  setTotalPages: () => {},
  setShowDisabledImobiliario: () => {},
  showDisabledImobiliario: false,
  setShowDisabledEdificacoes: () => {},
  showDisabledEdificacoes: false,
  setShowEdificacoesSemVinculos: () => {},
  showEdificacoesSemVinculos: false,
  setShowIncorporatedImobiliario: () => {},
  showIncorporatedImobiliario: false,
  setFilterPessoaByImobiliario: () => {},
  filterPessoaByImobiliario: true,
  reloadFields: false,
  setReloadFields: () => {},
  isLeitor: false,
});

/**
 * Provedor do Dashboard responsável por gerenciar metadados associados ao painel de controle.
 * @param {Object} props - Propriedades do componente.
 * @param {React.ReactNode} props.children - Componentes filhos a serem envolvidos pelo provedor do Dashboard.
 * @returns {JSX.Element} Retorna o provedor do Dashboard que gerencia os metadados do painel de controle.
 */
export function DashboardProvider({ children }: any) {
  const [metadata, setMetadata] = useState<IMetadata>({
    id_lote: undefined,
    id_imobiliario: undefined,
    id_pessoa: undefined,
    id_imobiliario_pessoa: undefined,
    id_edificacao: undefined,
    id_imobiliario_edificacao: undefined,
    id_midia: undefined,
    id_visitas: undefined,
    id_mensagens: undefined,
    formularios: undefined,
    drawer: true,
    permissoes: undefined,
  });

  const [errors, setErrors] = useState<IErrors>({});
  const [totalPages, setTotalPages] = useState<number>(1)
  const [showDisabledImobiliario, setShowDisabledImobiliario] = useState<boolean>(false);
  const [showDisabledEdificacoes, setShowDisabledEdificacoes] = useState<boolean>(false);
  const [showEdificacoesSemVinculos, setShowEdificacoesSemVinculos] = useState<boolean>(false);
  const [showIncorporatedImobiliario, setShowIncorporatedImobiliario] = useState<boolean>(false);
  const [filterPessoaByImobiliario, setFilterPessoaByImobiliario] = useState<boolean>(false);
  const [reloadFields, setReloadFields] = useState<boolean>(false);
  const isLeitor = metadata.permissoes?.permissao === "LEITOR";

  useEffect(() => {
    console.log("metadata has changed -> ", metadata);
  }, [metadata]);

  useEffect(() => {
    console.log("errors has changed -> ", errors);
  }, [errors]);

  return (
    <DashboardContext.Provider
      value={{
        metadata,
        setMetadata,
        errors,
        setErrors,
        totalPages,
        setTotalPages,
        showDisabledImobiliario,
        setShowDisabledImobiliario,
        showDisabledEdificacoes,
        setShowDisabledEdificacoes,
        showEdificacoesSemVinculos,
        setShowEdificacoesSemVinculos,
        showIncorporatedImobiliario,
        setShowIncorporatedImobiliario,
        reloadFields,
        setReloadFields,
        setFilterPessoaByImobiliario,
        filterPessoaByImobiliario,
        isLeitor
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
}
